import { BaseWebComponentView } from '../../../../../../../../framework/BaseWebComponentView';
import { GridViewWebComponent } from '../../../../../../../../grid/gridView';
import { WEB_COMPONENT_GRID_VIEW } from '../../../../../../../../webcomponents.constants';
import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { CveGridDataProvider } from '../dataProvider/CveGridDataProvider';
import { CveColumnIndexes, CveColumnKeys } from '../types';

export class CveGridView extends BaseWebComponentView {
  public patchId: string;

  public dom: {
    $gridView: GridViewWebComponent<CveColumnIndexes, CveColumnKeys>;
  };

  getDomElements(): void {
    this.dom.$gridView = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW);

    if (this.dom.$gridView.injectDependencies) {
      this.dom.$gridView.injectDependencies(this.dependencies);
      this.dom.$gridView.start().then().catch(console.error);
    }
  }

  buildView(): void {
    this.buildGridView();
  }

  private buildGridView() {
    const columnDetails: Array<ColumnDetails<CveColumnIndexes, CveColumnKeys>> = [
      {
        key: CveColumnKeys.CVE_ID,
        column: CveColumnIndexes.CVE_ID,
        columnName: translateFn('CVEs'),
        type: ColumnType.STRING,
        removable: false,
        sortable: true,
        flexGrow: 1,
      },
    ];

    this.dom.$gridView.propertiesSet = false;
    this.dom.$gridView.dataProvider = new CveGridDataProvider(this.dependencies);
    (this.dom.$gridView.dataProvider as CveGridDataProvider).patchId = this.patchId;
    this.dom.$gridView.hideHeaderActions = true;
    this.dom.$gridView.hideFiltersToggle = true;
    this.dom.$gridView.hideResetFilters = true;
    this.dom.$gridView.viewId = 'cve-grid';
    this.dom.$gridView.columns = [CveColumnIndexes.CVE_ID];
    this.dom.$gridView.predefinedFiltersKeys = [CveColumnKeys.CVE_ID];
    this.dom.$gridView.filters = [
      {
        [CveColumnKeys.CVE_ID]: { contains: '' },
      },
    ];
    this.dom.$gridView.allColumnDetails = columnDetails;
    this.dom.$gridView.hasSelectionExtraOptions = false;
    this.dom.$gridView.isCompactViewChecked = false;
    this.dom.$gridView.showToolbarRefresh = false;
    this.dom.$gridView.hasPagination = true;
    this.dom.$gridView.hideFooter = true;
    this.dom.$gridView.pageSize = 20;
    this.dom.$gridView.propertiesSet = true;
  }
}
